/* API do Tenant Message Bridge (admin). */
import ApiClient from './ApiClient';

class TenantMessageSourcesAPI extends ApiClient {
  constructor() {
    super('tenant_message_sources', { accountScoped: true });
  }
}

export default new TenantMessageSourcesAPI();
